import { Report } from 'notiflix/build/notiflix-report-aio'
import { Loading } from 'notiflix'
import axios from 'axios'
import { browserName, osName, deviceDetect, getUA } from 'react-device-detect'
import ReactPixel from 'react-facebook-pixel'
import { trackCompleteRegistration, trackLead } from './handleTracking'

interface uploadInterface {
    id: string
    files: any
}

const getSubdomain = () => {
    const url = window.location.origin
    let domain = url
    if (url.includes('://')) domain = url.split('://')[1]
    const subdomains = domain.split('.')
    return !subdomains[0].includes('www') ? subdomains[0] : subdomains[1]
}

const getLeadSource = (subdomain: any) => {
    const leadSources: any = {
        fb: 'Facebook',
        tk: 'TikTok',
        in: 'LinkedIn',
        ins: 'Instagram',
        yt: 'YouTube',
        claim: 'any',
        itvpcp: 'itv',
        nl: 'Newsletter',
        localhost: 'test',
    }
    return leadSources[subdomain]
}

export const uploadDataToServer = async (claimObject: any) => {
    console.log('This may take a minute.')
    Loading.standard('This may take a minute.')

    claimObject.device = osName
    claimObject.browser = browserName

    if (!claimObject.leadSource) claimObject.leadSource = getLeadSource(getSubdomain())

    console.log('Uploading claim data:', claimObject)

    try {
        const response = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_UPLOAD_DATA_URL}`,
            data: claimObject,
        })

        trackLead({ email: claimObject.email, phone: claimObject.phone })

        console.log('DATA UPLOAD RESPONSE: ', response.data)

        if (!response.data) {
            console.error('Invalid response data:', response.data)
            throw new Error('Invalid response data')
        }

        Loading.remove()
        return { success: true, responseData: response.data }
    } catch (error: any) {
        console.log('ERROR IS : ', error)
        Loading.remove()

        if (error.response && error.response.data) {
            Report.info(
                'Additional Claims',
                'We only require an initial claim, any additional claims will be investigated at a later date via automated checks.',
                'Thank you',
                () => {
                    window.location.href = 'https://sentinellegal.co.uk'
                }
            )
        } else {
            Report.failure('Error', 'Please refresh the page and try again.', 'okay')
        }
        return { success: false }
    }
}

export const updateDataToServer = async (claimObject: any) => {
    console.log('Updating claim data:', claimObject)
    try {
        const response = await axios({
            method: 'post',
            url: process.env.REACT_APP_API_UPDATE_LEAD_URL,
            data: claimObject,
        })
        console.log('Update response:', response.data)
        return { success: true, responseData: response.data }
    } catch (error) {
        console.error('Error updating claim data:', error)
        return { success: false, error: error }
    }
}

export const uploadFileToServer = async (id: string, files: any, idUploadOrigin: string) => {
    Loading.standard('Uploading files...')
    const formData = new FormData()

    let isID = false
    formData.append('id', id)
    // formData.append("file", fileToUpload, "file");
    files.forEach((fileToAttach: any) => {
        formData.append(fileToAttach.fileInputName, fileToAttach.file)
        if (fileToAttach.fileInputName == 'poid') {
            isID = true
            formData.append('type', idUploadOrigin)
        }
    })
    try {
        const response = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_UPLOAD_FILES_URL}`,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        console.log('FILE UPLOAD RESPONSE: ', response.data)
        if (isID) trackCompleteRegistration()

        Loading.remove()
        console.log('RESPONSE : ', response)

        return response?.data
    } catch (error: any) {
        Loading.remove()

        if (!error.response) {
            console.log('ERROR IS : ', error)
            if (error.message === 'No file provided') {
                Report.failure('No file selected', 'Please add a file and try again.', 'okay')
            } else {
                Report.failure('Error Ocurred', 'Please refresh the page and try again.', 'okay')
            }
        } else {
            const errorMessage = error.response.data.error.message
            if (errorMessage === 'Token not found') {
                Report.failure(
                    'Broken Link Used',
                    'Please click the link found in your "CFA signed" email to upload your ID.',
                    'okay'
                )
            } else if (errorMessage === 'Extension not accepted') {
                Report.failure('Incorrect file type', 'Please check the file type and try again.', 'okay')
            } else if (errorMessage === 'File exceeds 20MB') {
                Report.failure('File exceeds 20MB', 'Please use a smaller image and try again.', 'okay')
            } else if (errorMessage === 'Couldnt convert image.') {
                Report.failure('Use different Image', 'Please use a standard image format (PNG, JPEG, HEIC)', 'okay')
            } else {
                Report.failure('Error Ocurred', 'Please refresh the page and try again.', 'okay')
            }
        }

        return { success: false }
    }
}
